import React, { useEffect, useState } from 'react';
import { ProductContext } from '../../context/ProductContext.js';
import { useContext } from 'react';
import "./ProductList.css";
import { useImage } from "../../context/ImageContext.js";
import Loader from '../../components/Loader.js';
import { Helmet } from "react-helmet-async";
import ProductCard from '../../components/product/ProductCard.js';

// Favoriler için RTK Query hook'larını içe aktaralım
import { useGetFavoritesQuery, useAddToFavoriteMutation, useRemoveFromFavoriteMutation } from '../../services/favoriteApi';

const ProductList = () => {
    const { getImageUrl } = useImage();
    const { state, fetchProducts, dispatch } = useContext(ProductContext);
    const { products, loading, error } = state;
    const [currentPage, setCurrentPage] = useState(1);
    const [isFetching, setIsFetching] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const { data: favorites = [], refetch: loadFavorites } = useGetFavoritesQuery();
    const [addToFavorite] = useAddToFavoriteMutation();
    const [removeFromFavorite] = useRemoveFromFavoriteMutation();

    const isFavorite = (product) => {
        return favorites.some(favProduct =>
            String(favProduct.urun_id) === String(product.id)
        );
    };

    const handleFavoriteToggle = async (event, product) => {
        event.stopPropagation();
        event.preventDefault();

        try {
            if (isFavorite(product)) {
                const favoriteProduct = favorites.find(fav =>
                    String(fav.urun_id) === String(product.id)
                );
                if (favoriteProduct) {
                    await removeFromFavorite(favoriteProduct.favorite_id).unwrap();
                }
            } else {
                await addToFavorite(product.id).unwrap();
            }
        } catch (error) {
            console.error('Favori işlemi sırasında hata:', error);
        }
    };

    useEffect(() => {
        loadFavorites();
    }, []);

    useEffect(() => {
        const loadProducts = async () => {
            if (isFetching || !hasMore) return;

            setIsFetching(true);
            try {
                const result = await fetchProducts(currentPage);

                if (result && result.length < 20) {
                    setHasMore(false);
                }
            } catch (error) {
                console.error('Ürün yükleme hatası:', error);
            } finally {
                setIsFetching(false);
            }
        };

        if (currentPage > 1) {
            loadProducts();
        }
    }, [currentPage]);

    useEffect(() => {
        dispatch({ type: 'RESET_PRODUCTS' });
        setCurrentPage(1);
        setHasMore(true);

        const loadInitialProducts = async () => {
            setIsFetching(true);
            try {
                await fetchProducts(1);
            } catch (error) {
                console.error('İlk sayfa yükleme hatası:', error);
            } finally {
                setIsFetching(false);
            }
        };

        loadInitialProducts();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollThreshold = window.innerWidth < 768 ? 1300 : 700;
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - scrollThreshold &&
                !isFetching &&
                !loading &&
                hasMore
            ) {
                setCurrentPage(prev => prev + 1);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, isFetching, hasMore]);

    // RTK Query'nin loading state'ini de kontrol edelim
    const isInitialLoading = (loading && currentPage === 1) || favorites === undefined;

    if (isInitialLoading) return <Loader />;
    if (error) return <div>Hata: {error}</div>;

    // Kapora 1 ve stok 0 olan ürünleri filtrele
    const filteredProducts = products.filter(product => 
        !(product.kapora === 1 || product.stok === 0)
    );
    
    return (
        <>
            <Helmet>
                <title>BiKuyum | İkinci El Altınlar</title>
            </Helmet>

            <div className="products-container">
                <div className="productt-grid">
                    {filteredProducts.map((product, index) => (                        
                        <ProductCard
                            key={`${product.id}-${index}`}
                            product={product}
                            isFavorite={isFavorite}
                            onFavoriteToggle={handleFavoriteToggle}
                            showGramPrice={true}
                        />
                    ))}
                </div>

                {/* Scroll Loading Indicator */}
                {isFetching && hasMore && (
                    <div className=''>
                        <Loader />
                    </div>
                )}


            </div>
        </>
    );
};

export default ProductList;